












import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { DeleteOperLog, QueryLogList,ExportOperLog } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import constant from '@/utils/constant'
import SystemLogDialog from './components/SystemLogDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    SystemLogDialog
  },
})
export default class Log extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
    orderBy: ' oper_time desc'
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  // 查询条件
  private queryModels: Array<QueryModel> = [
    { title: '操作d地址', param: 'operIp' },
    { title: '操作模块', param: 'title' },
    { title: '操作人员', param: 'operName' },
    { title: '操作类型', param: 'businessType',type:"select",selectData: constant.OperLogBusinessType },
    { title: '状态', param: 'status', type: "select", selectData: constant.OperLogStatus },
    { title: '操作时间', param: 'operTimeDaterange', type: 'daterange' },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
    // { title: '清空日志', type: 'danger' },
    { title: '导出', type: 'warning', click: this.exportHandle },
  ]
  // 数据表头 -
  // 视频比例 ()
  private tableHander: Array<TableHander> = [
    { title: '日志编号', param: 'operId' },
    { title: '操作模块', param: 'title' },
    { title: '操作类型', param: 'businessType',slotName:"businessType" },
    { title: '操作人员', param: 'operName' },
    { title: '操作地址', param: 'operIp' },
    { title: '操作地点', param: 'operLocation' },
    { title: '操作状态', param: 'status',slotName:"status" },
    { title: '操作时间', param: 'operTime' , formatter: DateFormat,width: 160},
    { title: '消耗时间', param: 'costTime' , formatter: (v)=>v+'毫秒'},
    {
      title: '操作',
      operation: [
        { title: '详情' , click: this.openDetail },
        { title: '删除', click: this.delete },
      ],
    },
  ]

  private openDetail(data:any){
    const d = this.$refs.SystemLogDialog as SystemLogDialog
    d.open(data)
  }

  public async created() {
    this.loadData()
  }

  private getBusinessTypeTag(st:number){
    const ds = constant.OperLogBusinessType
    const rs = ds.filter(e=>e.value == st)
    if(rs && rs.length > 0){
      return rs[0]
    }
    return {
      label:st,
      value:st
    }
  }

  private getStatusTag(st:number){
    const ds = constant.OperLogStatus
    const rs = ds.filter(e=>e.value == st)
    if(rs && rs.length > 0){
      return rs[0]
    }
    return {
      label:st,
      value:st
    }
  }

  private delete(data: any) {
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await DeleteOperLog({ id: data.operId })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }


  private exportHandle(){
    // 导出
    // if(this.selectData.length <= 0){
    //   return
    // }

    const loading = this.$loading({
          lock: true,
          text: '正在导出日志',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      const param: any = this.getRequestParam()
      param.limit = ""
      param.startRow = ""
      param.orderBy = ""

      ExportOperLog(param,"操作日志导出.xlsx").then(res=>{
        loading.close()
      }).catch(()=>{
        loading.close()
      })

  }

  public async loadData() {
    const param = this.getRequestParam()
    const result = await QueryLogList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  private getRequestParam(){
    const param:any = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    if (param.operTimeDaterange) {
      param.operTimes = DateFormat(param.operTimeDaterange[0]) + ',' + DateFormat(param.operTimeDaterange[1])
    }

    return param
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
}
